import React from 'react';
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { colors } from 'Constants/Colors';

export default function ModalEdit({ cancel = () => {}, accept = () => {}, title = '', message = '' }) {
  const { t2 } = useTranslation('Generic');

  return (
    <div className="col">
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontFamily: 'var(--app-font)' }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {t2('Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand' }}
          color="success"
          onClick={async () => {
            accept();
          }}
          variant="contained"
        >
          {t2('Accept')}
        </Button>
      </DialogActions>
    </div>
  );
}
